import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LinearProgress } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { showError } from '../../actions/uiActions';
import FormsApi from '../../api/forms';
import { getFileTypeByExtension } from '../../utils/Validators';
import { CloudDownload, DocumentScanner, Close } from '@mui/icons-material';
import { extractFileLastName } from '../../utils/Formatter';
import IconButton from '@mui/material/IconButton';

class GenericFormPreview extends Component {
    state = {
        loading: true,
        fileName: '',
        content: '',
        selectFormPosition: 0
    }

    componentDidMount() {
        this.getDocument(this.props.form.files ? 0 : null)
    }

    getDocument = async (defaultPosition = 0, triggerDownload = false) => {
        this.setState({ loading: true });
        let response = null
        const isMultipleFile = triggerDownload && this.props.form.type === 'document' && this.props.form.files.length > 0;
        try {
            response = await FormsApi.downloadSignedForm(
                this.props.user,
                this.props.form.formId,
                this.props.form.form,
                triggerDownload,
                this.props.form.files?.[defaultPosition] ?? this.props.form.fileName,
                defaultPosition,
                isMultipleFile
            );
        } catch (error) {
            this.props.showError('An error occurred while fetching form');
        } finally {
            if (!triggerDownload && response && response.data) {
                const mimeType = getFileTypeByExtension(this.props.form.files?.[defaultPosition] ?? this.props.form.fileName,)
                const blob = new window.Blob([response.data], { type: mimeType });
                const reader = new FileReader();
                this.setState({
                    fileName: response.file.split(".")[0].replace(/_/g, " "),
                    content: URL.createObjectURL(blob),
                })
            }
            
            this.setState({ loading: false });
        }
    }

    downloadMultipleFile = () => {
        this.getDocument(null, true)
    }

    render() {
        return (
            <Dialog
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                open={true}
                maxWidth="xl"
                fullWidth={true}
                onClose={this.props.onClose}
                disableEscapeKeyDown={false}
            >
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    padding: '8px 16px',
                    backgroundColor: '#1b4b67',
                    color: 'white'
                }}>
                    <div>{this.state.fileName}</div>
                    <IconButton 
                        onClick={this.props.onClose}
                        style={{ color: 'white' }}
                        aria-label="close"
                    >
                        <Close />
                    </IconButton>
                </div>
                <DialogContent style={{ padding: 0 }}>
                    <DialogContentText
                        id="alert-dialog-description"
                        className="text-center"
                        style={{ margin: 0 }}
                    >
                        {this.state.loading && <LinearProgress />}
                        {!this.state.loading && (
                            <div className={`${this.props.form?.files ? 'flex space-between' :''}`} style={{ margin: 0 }}>
                                {this.props.form?.files?.length  > 1 && (
                                    <div className='flex flex-direction-col gap margin-top-30'>
                                        {this.props.form.files.map((file, index) => (
                                            <div className='document-wrap' key={index} onClick={() => {
                                                this.setState({ selectFormPosition: index })
                                                this.getDocument(index)
                                            }} style={{
                                                backgroundColor: index === this.state.selectFormPosition ? '#1b4b67' : '#284B6514',
                                                color: index === this.state.selectFormPosition ? '#FFFFFF' : '',
                                            }}
                                            >
                                                <div className='document'>
                                                    <DocumentScanner />
                                                    <span className='margin-left-10'>{extractFileLastName(file, `${this.props.user}/LETTER_TO_VERIFY_INCOME.pdffiles_`)}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                <div className="dynamic-form-wrapper" style={{ margin: 0, width:'100%' }}>
                                    {this.props.form?.files && (<div className='flex justify-content-end'>
                                        <div className='download-wrap' onClick={() => this.downloadMultipleFile()}>
                                            <CloudDownload />
                                        </div>
                                    </div>)}
                                    <embed src={this.state.content} className="dynamic-form-container" style={{ width: '100%', height: '80vh', padding: 0 }} />
                                </div>
                            </div>
                        )}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        )
    }
}

export default connect(null, { showError })(GenericFormPreview);
